import { KeyframeNode } from "./KeyframeNode";
import { AnimationEvent } from "./AnimationEvent";
import { FloatKeyframe } from "../../maths/FloatKeyframe";
import { QuaternionKeyframe } from "../../maths/QuaternionKeyframe";
import { Vector3Keyframe } from "../../maths/Vector3Keyframe";
export class AnimationClipParser03 {
    static READ_DATA() {
        AnimationClipParser03._DATA.offset = AnimationClipParser03._reader.readUint32();
        AnimationClipParser03._DATA.size = AnimationClipParser03._reader.readUint32();
    }
    static READ_BLOCK() {
        var count = AnimationClipParser03._BLOCK.count = AnimationClipParser03._reader.readUint16();
        var blockStarts = AnimationClipParser03._BLOCK.blockStarts = [];
        var blockLengths = AnimationClipParser03._BLOCK.blockLengths = [];
        for (var i = 0; i < count; i++) {
            blockStarts.push(AnimationClipParser03._reader.readUint32());
            blockLengths.push(AnimationClipParser03._reader.readUint32());
        }
    }
    static READ_STRINGS() {
        var offset = AnimationClipParser03._reader.readUint32();
        var count = AnimationClipParser03._reader.readUint16();
        var prePos = AnimationClipParser03._reader.pos;
        AnimationClipParser03._reader.pos = offset + AnimationClipParser03._DATA.offset;
        for (var i = 0; i < count; i++)
            AnimationClipParser03._strings[i] = AnimationClipParser03._reader.readUTFString();
        AnimationClipParser03._reader.pos = prePos;
    }
    static parse(clip, reader) {
        AnimationClipParser03._animationClip = clip;
        AnimationClipParser03._reader = reader;
        AnimationClipParser03.READ_DATA();
        AnimationClipParser03.READ_BLOCK();
        AnimationClipParser03.READ_STRINGS();
        for (var i = 0, n = AnimationClipParser03._BLOCK.count; i < n; i++) {
            var index = reader.readUint16();
            var blockName = AnimationClipParser03._strings[index];
            var fn = AnimationClipParser03["READ_" + blockName];
            if (fn == null)
                throw new Error("model file err,no this function:" + index + " " + blockName);
            else
                fn.call(null);
        }
    }
    static READ_ANIMATIONS() {
        var i, j;
        var node;
        var reader = AnimationClipParser03._reader;
        var startTimeTypes = [];
        var startTimeTypeCount = reader.readUint16();
        startTimeTypes.length = startTimeTypeCount;
        for (i = 0; i < startTimeTypeCount; i++)
            startTimeTypes[i] = reader.readFloat32();
        var clip = AnimationClipParser03._animationClip;
        clip.name = AnimationClipParser03._strings[reader.readUint16()];
        var clipDur = clip._duration = reader.readFloat32();
        clip.islooping = !!reader.readByte();
        clip._frameRate = reader.readInt16();
        var nodeCount = reader.readInt16();
        var nodes = clip._nodes;
        nodes.count = nodeCount;
        var nodesMap = clip._nodesMap = {};
        var nodesDic = clip._nodesDic = {};
        for (i = 0; i < nodeCount; i++) {
            node = new KeyframeNode();
            nodes.setNodeByIndex(i, node);
            node._indexInList = i;
            var type = node.type = reader.readUint8();
            var pathLength = reader.readUint16();
            node._setOwnerPathCount(pathLength);
            for (j = 0; j < pathLength; j++)
                node._setOwnerPathByIndex(j, AnimationClipParser03._strings[reader.readUint16()]);
            var nodePath = node._joinOwnerPath("/");
            var mapArray = nodesMap[nodePath];
            (mapArray) || (nodesMap[nodePath] = mapArray = []);
            mapArray.push(node);
            node.propertyOwner = AnimationClipParser03._strings[reader.readUint16()];
            var propertyLength = reader.readUint16();
            node._setPropertyCount(propertyLength);
            for (j = 0; j < propertyLength; j++)
                node._setPropertyByIndex(j, AnimationClipParser03._strings[reader.readUint16()]);
            var fullPath = nodePath + "." + node.propertyOwner + "." + node._joinProperty(".");
            nodesDic[fullPath] = node;
            node.fullPath = fullPath;
            var keyframeCount = reader.readUint16();
            node._setKeyframeCount(keyframeCount);
            for (j = 0; j < keyframeCount; j++) {
                switch (type) {
                    case 0:
                        var floatKeyframe = new FloatKeyframe();
                        node._setKeyframeByIndex(j, floatKeyframe);
                        floatKeyframe.time = startTimeTypes[reader.readUint16()];
                        floatKeyframe.inTangent = reader.readFloat32();
                        floatKeyframe.outTangent = reader.readFloat32();
                        floatKeyframe.value = reader.readFloat32();
                        break;
                    case 1:
                    case 3:
                    case 4:
                        var floatArrayKeyframe = new Vector3Keyframe();
                        node._setKeyframeByIndex(j, floatArrayKeyframe);
                        floatArrayKeyframe.time = startTimeTypes[reader.readUint16()];
                        var inTangent = floatArrayKeyframe.inTangent;
                        var outTangent = floatArrayKeyframe.outTangent;
                        var value = floatArrayKeyframe.value;
                        inTangent.x = reader.readFloat32();
                        inTangent.y = reader.readFloat32();
                        inTangent.z = reader.readFloat32();
                        outTangent.x = reader.readFloat32();
                        outTangent.y = reader.readFloat32();
                        outTangent.z = reader.readFloat32();
                        value.x = reader.readFloat32();
                        value.y = reader.readFloat32();
                        value.z = reader.readFloat32();
                        break;
                    case 2:
                        var quaArrayKeyframe = new QuaternionKeyframe();
                        node._setKeyframeByIndex(j, quaArrayKeyframe);
                        quaArrayKeyframe.time = startTimeTypes[reader.readUint16()];
                        var inTangentQua = quaArrayKeyframe.inTangent;
                        var outTangentQua = quaArrayKeyframe.outTangent;
                        var valueQua = quaArrayKeyframe.value;
                        inTangentQua.x = reader.readFloat32();
                        inTangentQua.y = reader.readFloat32();
                        inTangentQua.z = reader.readFloat32();
                        inTangentQua.w = reader.readFloat32();
                        outTangentQua.x = reader.readFloat32();
                        outTangentQua.y = reader.readFloat32();
                        outTangentQua.z = reader.readFloat32();
                        outTangentQua.w = reader.readFloat32();
                        valueQua.x = reader.readFloat32();
                        valueQua.y = reader.readFloat32();
                        valueQua.z = reader.readFloat32();
                        valueQua.w = reader.readFloat32();
                        break;
                    default:
                        throw new Error("AnimationClipParser03:unknown type.");
                }
            }
        }
        var eventCount = reader.readUint16();
        for (i = 0; i < eventCount; i++) {
            var event = new AnimationEvent();
            event.time = Math.min(clipDur, reader.readFloat32());
            event.eventName = AnimationClipParser03._strings[reader.readUint16()];
            var params = [];
            var paramCount = reader.readUint16();
            (paramCount > 0) && (event.params = params = []);
            for (j = 0; j < paramCount; j++) {
                var eventType = reader.readByte();
                switch (eventType) {
                    case 0:
                        params.push(!!reader.readByte());
                        break;
                    case 1:
                        params.push(reader.readInt32());
                        break;
                    case 2:
                        params.push(reader.readFloat32());
                        break;
                    case 3:
                        params.push(AnimationClipParser03._strings[reader.readUint16()]);
                        break;
                    default:
                        throw new Error("unknown type.");
                }
            }
            clip.addEvent(event);
        }
    }
}
AnimationClipParser03._strings = [];
AnimationClipParser03._BLOCK = { count: 0 };
AnimationClipParser03._DATA = { offset: 0, size: 0 };
